import { useEffect, useRef } from 'react';

type Opts = {
  enabled: boolean; // вкл/выкл ожидание скана
  onScan: (text: string) => void; // колбэк с готовой строкой
  endKeys?: string[]; // клавиши-завершители (обычно Enter/Tab)
  maxGapMs?: number; // макс. пауза между символами
  minLength?: number; // минимальная длина
};

export function useBarcodeScanner({
  enabled,
  onScan,
  endKeys = ['Enter', 'Tab', 'NumpadEnter'],
  maxGapMs = 80,
  minLength = 3,
}: Opts) {
  // буфер и таймеры
  const bufRef = useRef('');
  const lastTsRef = useRef(0);
  const tRef = useRef<number | null>(null);

  useEffect(() => {
    if (!enabled || process.env.REACT_APP_LOYALTY_BARCODE_ACTIVE !== 'true')
      return;

    // отдать накопленное
    const flush = () => {
      const val = bufRef.current.trim();
      bufRef.current = '';
      if (val.length >= minLength) onScan(val);
    };

    const onKeyDown = (e: KeyboardEvent) => {
      // Enter/Tab/NumpadEnter завершают скан
      if (endKeys.includes(e.key)) {
        e.preventDefault();
        flush();
        return;
      }

      // пропускаем только печатные символы
      if (e.key.length !== 1) return;

      const now = Date.now();
      // если была большая пауза — считаем, что это новый скан и чистим буфер
      if (now - lastTsRef.current > maxGapMs) {
        bufRef.current = '';
      }
      lastTsRef.current = now;

      bufRef.current += e.key;

      // если сканер не шлёт Enter — завершаем по таймауту
      if (tRef.current) window.clearTimeout(tRef.current);
      tRef.current = window.setTimeout(flush, maxGapMs + 20);
    };

    window.addEventListener('keydown', onKeyDown, true);
    return () => {
      window.removeEventListener('keydown', onKeyDown, true);
      if (tRef.current) window.clearTimeout(tRef.current);
    };
  }, [enabled, onScan, endKeys, maxGapMs, minLength]);
}
